import {useState} from 'react';
import {useAuth} from '../context/AuthContext';

const keyFor = uid => `sayyadi-reading-v1:${uid}`;
export function readProgress(uid) {
  if (!uid) return null;
  try {
    const value = JSON.parse(localStorage.getItem(keyFor(uid)));
    if (value?.enabled !== true) return null;
    const {surah, ayah} = value;
    if (!Number.isInteger(surah) || surah < 1 || surah > 114 || !Number.isInteger(ayah) || ayah < 1 || ayah > 286) return null;
    return {enabled:true, surah, ayah};
  } catch {return null;}
}
// Explicit opt-in, on this browser only. A different account never sees this position.
export default function useQuranProgress() {
  const {user} = useAuth(), uid = user?.user_id;
  const [revision, refresh] = useState(0);
  const progress = readProgress(uid);
  function save(surah, ayah) {
    if (!uid) return false;
    try {localStorage.setItem(keyFor(uid), JSON.stringify({enabled:true, surah, ayah})); refresh(revision+1); return true;} catch {return false;}
  }
  function clear() {
    if (!uid) return false;
    try {localStorage.removeItem(keyFor(uid)); refresh(revision+1); return true;} catch {return false;}
  }
  return {progress, save, clear};
}
